module.exports = __webpack_public_path__ + "img/nav3.1348fa1f.png";